<template lang="pug">
div.video-block
    div
        iframe.fullfill(ref="videoFrame" :src="sourceLink" webkitallowfullscreen mozallowfullscreen allowfullscreen)
</template>

<script>
import Block from './Block.vue'
export default {
    name: 'video-block',
    extends: Block,
    data() { return { player: null } },
    mounted() {
        console.log(this.sourceLink)
        if (this.hosting == "youtube") this.player = new YT.Player(this.$refs.videoFrame);
        if (this.hosting == "vimeo") this.player = new Vimeo.Player(this.$refs.videoFrame);
    },
    computed: {
        hosting() {
            if (this.content.indexOf('youtube#') !== -1) return "youtube";
            if (this.content.indexOf('vimeo#') !== -1) return "vimeo";
            return null;
        },
        sourceId() {
            var res = this.content.split("#");
            return res.length > 1 ? res[1] : "";
        },
        sourceLink() {
            if (this.hosting == "youtube")
                return "http://www.youtube.com/embed/" + this.sourceId + "?enablejsapi=1"
            if (this.hosting == "vimeo") 
                return "https://player.vimeo.com/video/" + this.sourceId + "?title=0&byline=0&portrait=0";
            return "";
        }
    },
    methods: {
        pause: function() {
            this.$emit('pause');
            if (this.hosting == "youtube") this.player.pauseVideo();
            if (this.hosting == "vimeo") this.player.pause();
        },
        play: function() {
            this.$emit('play');
            if (this.hosting == "youtube") this.player.playVideo();
            if (this.hosting == "vimeo") this.player.play();
        }
    }
}
</script>

<style lang="scss" scoped>
.video-block > div {
    position: relative;
    height: 0;
    padding-bottom: 56.25%;
    overflow: hidden;
    iframe {
        border: none;
    }
}
</style>




// WEBPACK FOOTER //
// VideoBlock.vue?0bc83b99